import { i18n } from '@v4/locale/async';
/**
 * Generates a chip in case when we need to generate it manually,
 * because we don't get it from API,
 * e.g. when the invalid zipcode is inserted.
 * @param {string} chipTitle The lable we want to put on the chip.
 * @param {string} href The href for data fetching on chip click.
 * @returns {object} The chip object, structured as the one we would receive from API.
 */
export default function generateChip(chipTitle, href) {
    const chip = {
        id: 'filters',
        title: i18n.t('search-page.button.filters'),
        type: 'chip',
        items: [
            {
                name: chipTitle,
                label: chipTitle,
                active: true,
                deletable: true,
                href,
                num: 0,
                score: -1,
            },
        ],
        collapsed: false,
        isExpandable: false,
        isExpanded: false,
        description: false,
        listToggleText: false,
    };
    return chip;
}
